export default __webpack_public_path__ + "static/selfridges-yellow-b8f9bcda8034811e3994afa1d286dd4c.png";